import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/pages/TermsPage.tsx");
